/**
 * @author Andres Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IBodegasTiposPropiedades from 'Infotrack@Modelos/smartStock/bodegasTiposPropiedades/entidades/bodegasTiposPropiedades';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IBodegasTiposPropiedades>> => [
    {
        title: formatMessage({ id: 'bodegasTiposPropiedades.bodegaTipoPropiedadDescripcion' }),
        field: 'BodegaTipoPropiedadDescripcion',
    },
    {
        title: formatMessage({ id: 'bodegasTiposPropiedades.propiedad' }),
        field: 'Propiedad',
    },
    {
        title: formatMessage({ id: 'productos.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, bodegasTiposPropiedades?: IBodegasTiposPropiedades) => void,
    cargarBodegasTiposPropiedades: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (bodegasTiposPropiedades: IBodegasTiposPropiedades) => void
): Array<Action<IBodegasTiposPropiedades>> => [
    {
        component: BotonAgregar,
        icon: () => <AddIcon />,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IBodegasTiposPropiedades),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon />,
        onClick: cargarBodegasTiposPropiedades,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IBodegasTiposPropiedades),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IBodegasTiposPropiedades> = {
    maxBodyHeight: '50vh',
};
